exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-2b5b45b8] .el-input__inner,[data-v-2b5b45b8] .el-textarea__inner {\n  border: none;\n  border-radius: 0;\n  resize: none;\n  padding-left: 0;\n  padding-right: 0;\n  border-bottom: 1px solid #d9d9d9;\n}\n[data-v-2b5b45b8] .el-dialog__title {\n  font-size: 25px;\n  color: #606266;\n}\n[data-v-2b5b45b8] .el-form-item__label {\n  font-family: Arial, Helvetica, sans-serif;\n}\n", ""]);

// exports
